exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".red[data-v-08ec42e2] {\n  color: red;\n}\n.blue[data-v-08ec42e2] {\n  color: blue;\n}\n.green[data-v-08ec42e2] {\n  color: green;\n}\n", ""]);

// exports
